<template>
  <!-- 加了class -->
  <svg :class="classNames" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 16 16" fill="none">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.8008 10.5H4.99805C4.66743 10.5 4.39941 10.231 4.39941 9.89914C4.39941 9.76257 4.44577 9.63007 4.53084 9.52349L8.31539 4.78153C8.57376 4.45779 9.04469 4.40558 9.36724 4.66491C9.41011 4.69939 9.44907 4.73849 9.48342 4.78153L13.268 9.52349C13.4747 9.78248 13.4331 10.1606 13.175 10.3681C13.0688 10.4535 12.9368 10.5 12.8008 10.5Z" fill="black" fill-opacity="0.2" />
  </svg>
</template>

<script lang="ts">
import { computed, defineComponent, toRefs } from 'vue';

export default defineComponent({
  name: 'ExpandIcon',

  props: {
    isRotate: {
      type: Boolean,
      default: false,
    },
  },

  setup(props) {
    const { isRotate } = toRefs(props);

    const classNames = computed(() => {
      return !isRotate.value ? 'rotate' : '';
    });

    return {
      classNames,
    };
  },
});
</script>

<style lang="scss" scoped>
.rotate {
  transform: rotate(180deg);
  transform-origin: 50% 50%;
}
</style>
